export default "__VITE_ASSET__3w3kf5gI__"